import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const UpdateOrderEntryItemRequestNoteDocument = gql`
  mutation UpdateOrderEntryItemRequestNote(
    $variantPackId: uuid!
    $supplierId: uuid!
    $restaurantId: uuid!
    $collectionId: uuid!
    $request: String
    $persistRequest: Boolean!
  ) {
    updateOrderEntryItemRequestNote(
      variant_pack_id: $variantPackId
      supplier_id: $supplierId
      restaurant_id: $restaurantId
      collection_id: $collectionId
      request: $request
      persist_request: $persistRequest
    ) {
      success
    }
  }
`;
export type UpdateOrderEntryItemRequestNoteMutationFn = Apollo.MutationFunction<
  Types.UpdateOrderEntryItemRequestNoteMutation,
  Types.UpdateOrderEntryItemRequestNoteMutationVariables
>;
export function useUpdateOrderEntryItemRequestNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateOrderEntryItemRequestNoteMutation,
    Types.UpdateOrderEntryItemRequestNoteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateOrderEntryItemRequestNoteMutation,
    Types.UpdateOrderEntryItemRequestNoteMutationVariables
  >(UpdateOrderEntryItemRequestNoteDocument, options);
}
export type UpdateOrderEntryItemRequestNoteMutationHookResult = ReturnType<
  typeof useUpdateOrderEntryItemRequestNoteMutation
>;
export type UpdateOrderEntryItemRequestNoteMutationResult =
  Apollo.MutationResult<Types.UpdateOrderEntryItemRequestNoteMutation>;
export type UpdateOrderEntryItemRequestNoteMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateOrderEntryItemRequestNoteMutation,
    Types.UpdateOrderEntryItemRequestNoteMutationVariables
  >;
